module.exports = __webpack_public_path__ + "static/media/recall.3f17dc08.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/recollect/recall.mp4
// module id = 349
// module chunks = 0